import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { get } from 'lodash-es';

@Component({
  selector: 'wms-spinner',
  standalone: true,
  templateUrl: './wms-spinner.component.html',
  styleUrls: ['./wms-spinner.component.less'],
  imports: [
    CommonModule
  ]
})
export class WmsSpinnerComponent implements OnInit {

  @Input() size = 'lg';
  @Input() caption?: string;

  SPINNER_TYPES = {
    'sm': {'radius': 15, 'class': 'small'},
    'md': {'radius': 20, 'class': 'medium'},
    'lg': {'radius': 25, 'class': 'large'}
  };
  spinnerType;

  constructor() { 
    this.spinnerType = get(this.SPINNER_TYPES, this.size);
  }

  ngOnInit(): void {
  }

}
